// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TokenPriceChange_wrapper__WSVfr","valueWithIcon":"TokenPriceChange_valueWithIcon__30zpQ","icon":"TokenPriceChange_icon__X7mz0"};